import * as TY from 'containers/pages/users/constants';

const initValid = {
	[TY.F_NAME]: { isErr: false, errMsg: '', canNotSave: true },
	[TY.L_NAME]: { isErr: false, errMsg: '', canNotSave: true },
	[TY.COMPANIES]: { isErr: false, errMsg: '', canNotSave: true },
	[TY.EMAIL_WORK]: { isErr: false, errMsg: '', canNotSave: false },
	[TY.EMAIL_PERSONAL]: { isErr: false, errMsg: '', canNotSave: false },
	[TY.EMAIL_OTHER]: { isErr: false, errMsg: '', canNotSave: false },
	[TY.CONTACT_TYPES]: { isErr: false, errMsg: '', canNotSave: false },
	[TY.PHONE_WORK]: { isErr: false, errMsg: '', canNotSave: false },
	[TY.PHONE_MOBILE]: { isErr: false, errMsg: '', canNotSave: false },
	[TY.PHONE_OTHER]: { isErr: false, errMsg: '', canNotSave: false },
	[TY.U_NAME]: { isErr: false, errMsg: '', canNotSave: true },
	[TY.PWD]: { isErr: false, errMsg: '', canNotSave: false },
	[TY.CONFIRM_PWD]: { isErr: false, errMsg: '', canNotSave: false },
	[TY.MST_CUST_ID]: { isErr: false, errMsg: '', canNotSave: false },
	[TY.APPS]: { isErr: false, errMsg: '', canNotSave: false },
	[TY.ROLES]: { isErr: false, errMsg: '', canNotSave: true },
};

export default initValid;
